export const SKYMILES_LOGIN_URL = '/skymiles/login';
